import { useTranslation } from 'react-i18next';
import ReactECharts from "echarts-for-react";
import { Stack, Typography } from '@mui/material';
import {getChartTitle} from './trendChartutils'
const TrendHeatmap = (props) => {

    const { data, timeAggType, currencySymbol, graphType } = props;
    const { t } = useTranslation();
    
    const timestamps = data?.timestamps
    
    const dataForGraphType = data?.data.filter(
        (d) => d.metadata.key === graphType
    );

    const series = [];

    const yaxis = dataForGraphType.map((curve) => `${curve.metadata.location} - ${curve.metadata.system} - ${curve.metadata.identifier.slice(-4)}`);

    for (
        let seriesIndex = 0;
        seriesIndex < dataForGraphType.length;
        seriesIndex++
    ) {
        let currentSeries = [];

        for (let dataIndex = 0; dataIndex < timestamps.length; dataIndex++) {
            let dataPoint = dataForGraphType[seriesIndex]["values"][dataIndex]
            
            if (graphType === 'ON_OFF') {
                dataPoint = dataPoint === 'active' ? 1 : 0
            }

            currentSeries.push([dataIndex, seriesIndex, dataPoint]);
        }

        series.push({
            data: currentSeries,
            name: yaxis[seriesIndex],
            type: "heatmap",
            itemStyle: {
                normal: {
                    borderColor: '#DDDDDD', 
                    borderWidth: 1        
                }
            }
        });
    }
    const mapping = {
		1: "Auto",
		2: "Heat",
		3: "Dry",
		4: "Fan",
		5: "Cool",
		6: "Auto Heat",
		7: "Auto Cool",
		8: "Setback",
		9: "Setback Heat",
		10: "Setback Cool",
	};

    const title = getChartTitle(graphType, t, currencySymbol)

	const options = {
		tooltip: {
			position: "top",
            confine: true,
			valueFormatter: (value) => mapping[parseInt(value)],
		},
		grid: {
			top: 0,
			bottom: 50,
            left: '5%',
            right: '5%'
		},
		xAxis: {
			type: "category",
			data: timestamps,
			splitArea: {
				show: true,
			},
		},
		yAxis: {
			type: "category",
			data: yaxis,
			splitArea: {
				show: true,
			},
            axisLabel: {
                formatter: function(value) {
                    return value.slice(0, 6) + '...'
                }
            }
		},
		textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        },
		series,
	};

    if (graphType === 'MODE') {
        options.visualMap= {
			type: "piecewise",
			splitNumber: 10,
			min: 0,
			max: 10,
			calculable: true,
			realtime: false,
			orient: "horizontal",
			left: "center",
			bottom: "0%",
			pieces: [
				{ min: 0, max: 1, label: "Auto", color: "#008FFB" },
				{ min: 1, max: 2, label: "Heat", color: "#00E396" },
				{ min: 2, max: 3, label: "Dry", color: "#FEB019" },
				{ min: 3, max: 4, label: "Fan", color: "#FF4560" },
				{ min: 4, max: 5, label: "Cool", color: "#775DD0" },
				{ min: 5, max: 6, label: "Auto Heat", color: "#f46a9b" },
				{ min: 6, max: 7, label: "Auto Cool", color: "#27aeef" },
				{ min: 7, max: 8, label: "Setback", color: "#b33dc6" },
				{ min: 8, max: 9, label: "Setback Heat", color: "#87bc45" },
				{ min: 9, max: 10, label: "Setback Cool", color: "#9c4a44" },
			],
			showLabel: true,
			textStyle: {
				color: "black",
			},
		}
    } else if ( 'ON_OFF' === graphType) {
        options.visualMap = {
            type: 'piecewise',
            min: 0,
            max: 1,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            bottom: '0%',
            pieces : [
				{ min: 0, max: 0, label: "OFF", color: "#008FFB" },
				{ min: 1, max: 1, label: "ON", color: "#00E396" },
            ]
          }
          options.tooltip = {
			position: "top",
            valueFormatter: (value) => value===1 ? 'On' : 'Off',
		}

        if (graphType === 'ON_OFF') {
            options.visualMap.pieces = [
				{ min: 0, max: 0, label: "OFF", color: "#008FFB" },
				{ min: 1, max: 1, label: "ON", color: "#00E396" },
            ]
        }


    } else if ('MOTION'  === graphType) {
        options.visualMap = {
            type: 'continuous',
            inRange: {
                color: ['white', "#008FFB"]
            },
            min: 0,
            max: 1, 
            orient: 'horizontal',
            left: 'center',
            bottom: '0%',
            show: false
          }
          options.tooltip = {
			position: "top",
            valueFormatter: (value) => Math.round(value * 100) + '%',
		}



    }  else {
        options.tooltip = {
			position: "top",
		}
        options.visualMap = {
            min: 0,
            max: 10,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            bottom: '15%'
          }
    }

	return (
		<Stack>
            <Typography padding={1} align="center" component="h2" variant="h6" color="primary" gutterBottom>{title}</Typography>    
			<ReactECharts option={options} />
		</ Stack>
	);
}
 
export default TrendHeatmap;